module.exports = __webpack_public_path__ + "img/bg-th2.0acf2d52.png";